<template>
  <div class="upload-content"
    v-loading.fullscreen.lock="loading"
    :element-loading-text="pageText.onTheCross">
    <div class="download-template upload-content-info">
      <slot name="guide">
        <a @click="downloadFile" class="download-file">
          <span></span>
        </a>
        <p>{{pageText.downLoadTemplate}}</p>
      </slot>
    </div>
    <div class="upload-group upload-content-info">
      <sy-upload
        ref="fe-upload"
        class="upload"
        :isChunk="isChunk"
        :extend="extend"
        :business="business"
        :action="action"
        :data="data"
        :accept="uploadConfig.accept"
        :auto-upload="autoUpload"
        :multiple="uploadConfig.multiple"
        :showFileList="uploadConfig.showFileList"
        :before-upload="beforeUpload"
        :on-change="changeFile"
        :on-success="uploadSuccess"
        :on-error="uploadError"
      >
        <div class="upload-success upload-content-info" v-show="isUpload">
          <div class="upload-success-icon"></div>
        </div>
      </sy-upload>
      <div v-show="!isUpload && tips">
        <p slot="trigger">{{pageText.uploadImportFile}}</p>
        <p class="upload-tips">（{{tip || variableReplace(pageText.supportedFormats, {m: '.xls/.xlsx', n: '5M'})}}）</p>
      </div>
      <div v-show="!isUpload && !tips">
        <slot name='tipSlot' :tip="variableReplace(pageText.supportedFormats, {m: '.xls/.xlsx', n: '5M'})">
          <p class="upload-tips">{{tip || variableReplace(pageText.supportedFormats, {m: '.xls/.xlsx', n: '5M'})}}</p>
        </slot>
      </div>
      <p v-show="isUpload">
        <span class="file-name">{{file.name}}</span>
        <span class="file-size">（{{autoUpload ? file.size : file.size / 1024}}k）</span>
        <i class="el-icon-delete" @click="deleteFile"></i>
      </p>
    </div>
  </div>
</template>

<script>
  import response from '../../../utils/response'
  import syUpload from '../../basis/sy-upload/upload.vue'
  import i18n from './i18n.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    props: {
      // 是否支持分片上传
      isChunk: {
        type: Boolean,
        default: false
      },
      // 分片上传的拓展参数
      extend: {
        type: [String, Object],
        default: null
      },
      // init请求参数的业务代码
      business: {
        type: [String, Object],
        default: null
      },
      tips: {
        type: Boolean,
        default: true
      },
      // 下载前的校验
      downloadValidate: {
        type: Object,
        default: {
          url: '',
          method: '',
          param: {}
        }
      },
      // 下载模板文件地址
      downloadTemplate: {
        type: String,
        default: ''
      },
      // 上传地址
      action: {
        type: String
      },
      // 是否自动上传
      autoUpload: {
        type: Boolean,
        default: true
      },
      // 上传时附带额外的参数
      data: {
        type: Object
      },
      tip: {
        type: String,
        default: ''
      },
      // 下载模板方法
      downloadFn: Function
    },
    data () {
      return {
        pageText,
        uploadConfig: {
          // 是否支持多选文件
          multiple: false,
          // 上传文件类型
          accept: 'xls,xlsx',
          // 是否显示上传列表
          showFileList: false
        },
        file: {
          name: '',
          size: ''
        },
        valid: true,
        isUpload: false,
        loading: false
      }
    },
    methods: {
      variableReplace: window.fe.variableReplace,
      // 下载文件，先进行校验
      async downloadFile () {
        if (!this.downloadFn) {
          if (this.downloadValidate && this.downloadValidate.url) {
            const {url, type, param} = this.downloadValidate
            const res = await response(this.$http(type, url, param), {
              loadingOptions: true
            })
            if (!res.isOk) {
              return
            }
          }
          window.open(this.downloadTemplate)
        } else {
          // 自定义下载方法
          this.downloadFn()
        }
      },
      // 删除文件
      deleteFile () {
        this.reset()
        this.$emit('changeFiles', null)
      },
      // 手动上传
      submitUpload () {
        if (this.file.name === '') {
          return this.$message({
            type: 'error',
            message: this.pageText.pleaseSelectAFileAndUploadIt
          })
        }
        this.$refs['fe-upload'].submit()
      },
      uploadSuccess (response) {
        if (response.code !== 'success') {
          this.reset()
          this.$message.error(response.errorMessage || this.pageText.uploadFailedPleaseReupload)
          return false
        } else {
          this.isUpload = true
          this.$emit('uploadSuccess', response)
          this.loading = false
        }
      },
      // 上传失败
      uploadError () {
        this.reset()
        this.loading = false
      },
      // 自定义上传
      beforeUpload (file) {
        if (this.isChunk) return true
        if (file.id !== this.file.id) return false
        if (!file) {
          this.$message({
            type: 'error',
            message: this.pageText.pleaseSelectAFileAndUploadIt
          })
          return false
        }
        this.file.name = file.name
        this.file.size = Math.round(file.size / 1024)
        let extensionStr = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extensionIsRight = extensionStr === 'xls' || extensionStr === 'xlsx'
        if (!extensionIsRight) {
          this.$message({
            type: 'error',
            message: this.variableReplace(this.pageText.uploadFileFormat, {m: '.xls/.xlsx', n: '5M'})
          })
          // 清空文件
          this.$refs['fe-upload'].clearFiles()
          this.deleteFile()
          return false
        }
        // 限制上传文件为5M
        let sizeIsSatisfy = file.size < 5 * 1024 * 1024
        if (!sizeIsSatisfy) {
          this.$message({
            type: 'error',
            message: this.variableReplace(this.pageText.uploadFileFormat, {m: '.xls/.xlsx', n: '5M'})
          })
          // 清空文件
          this.$refs['fe-upload'].clearFiles()
          this.deleteFile()
          return false
        }
        this.loading = true
      },
      changeFile (file) {
        this.file = file
        this.isUpload = true
        this.$emit('changeFiles', file)
      },
      // 对外方法用于重置状态 this.$refs['name'].reset()
      reset () {
        this.$nextTick(() => {
          this.$refs['fe-upload'] && this.$refs['fe-upload'].uploader.removeFile(this.file)
          this.loading = false
          this.isUpload = false
          this.file.size = ''
          this.file.name = ''
          this.file.status = ''
          this.file.key = ''
          this.$refs['fe-upload'] && this.$refs['fe-upload'].clearFiles()
          if (this.$refs['fe-upload']) this.$refs['fe-upload'].files = []
        })
      }
    },
    components: {
      syUpload
    }
  }
</script>

<style lang="scss">

  .upload-content {
    font-size: 12px;
    color: #333;
    padding-top: 48px;
    text-align: center;
    .upload-content-info{
      vertical-align: top;
      display: inline-block;
      text-align: center;
    }
    .download-file {
      cursor: pointer;
    }
    .download-template{
      margin-right: 238px;
      vertical-align: top;
      font-size: 12px;
      color: #333;
      display: inline-block;
      a{
        display: inline-block;
        height: 104px;
        margin-bottom: 8px;
        span{
          display: inline-block;
          width: 104px;
          height: 104px;
          background: url($img-url + "160929844644212181.svg") no-repeat;
        }
      }
    }
    .upload-group{
      .upload{
        width: 104px;
        height: 104px;
        background: url($img-url + "160929845066116732.svg") no-repeat;
        margin: 0 auto 8px;
        .sy-upload-trigger{
          width: 100%;
          height: 100%;
        }
      }
      .upload-tips{
        line-height: 20px;
        color: #3F3F3F;
        letter-spacing: 0.67px;
        opacity: 0.7;
      }
    }

    .upload-success{
      .upload-success-icon{
        width: 104px;
        height: 104px;
        background: url($img-url + "155255068976757094.png") no-repeat;
        margin: 0 auto 8px;
        background-size: 100%;
      }
      p {
        .file-name {
          max-width: 150px;
          overflow: hidden;
        }
        .file-size,i{
          color: #3F3F3F;
          opacity: 0.7;
        }
        i.el-icon-delete {
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }
</style>
